<template>
  <section class="evento-lux">

    <!-- ===== TARJETA 2: RECEPCIÓN ===== -->
    <article ref="card2" class="card" aria-label="Recepción">
      <img class="icono" src="@/assets/coroa.png" alt="" loading="lazy" />
      <h3 class="titulo-script">Celebración</h3>
      <p class="hora">4:30 PM</p>
      <p class="lugar">Gemstone Palaces</p>
      <p class="direccion">
        1101 Bunton Creek Rd <br />Kyle, Texas.
      </p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/wcLjS4NF5S23xSqy8"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>

  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card2 = ref(null)
    const btn2 = ref(null)
    let ctx = null

    const animCard = (cardEl, btnEl) => {
      if (!cardEl) return

      const $ = gsap.utils.selector(cardEl)
      const elementosInternos = $('.icono, .titulo-script, .hora, .lugar, .direccion')

      // Aceleración por hardware dedicada
      gsap.set([cardEl, btnEl, ...elementosInternos], { force3D: true })

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 90%', // Disparo anticipado e instantáneo
          once: true // Mata el trigger tras ejecutarse para liberar RAM
        }
      })

      // 1. Revelado de la tarjeta
      tl.fromTo(
        cardEl,
        { autoAlpha: 0, y: 30 },
        { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power1.out' }
      )
      // 2. Revelado agrupado ultraligero de todo el contenido interno
      .fromTo(
        [elementosInternos, btnEl],
        { autoAlpha: 0, y: 15 },
        { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.05, ease: 'power1.out' },
        '-=0.3'
      )
    }

    onMounted(() => {
      ctx = gsap.context(() => {
        animCard(card2.value, btn2.value)
      })
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return { card2, btn2 }
  }
}
</script>

<style scoped>
/* ==================== ssssssssBASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux{
  min-height: 100%;
  padding: 8px 18px 4px;
    margin-top:0px;

  background: #f0c9d3;
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card{
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  padding: 24px 20px 28px;
    margin-bottom: 50px;          /* pequeño respiro respecto a la tarjeta */

  background: #f0c9d3;
  text-align: center;
}

/* Icono discreto */
.icono{
  width: 122px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}

/* Tipos (usa tus fuentes ya cargadas) */
.titulo-script {
  font-family: 'CynthiaJuneJF', cursive;
  font-weight: 400;
  font-size: 66px;
  letter-spacing: .4px;
  margin: 4px 0 8px;

  /* --- EFECTO DORADO MÁGICO --- */
  background: linear-gradient(
    110deg,
    #a67c00 30%,   /* Oro profundo */
    #bf953f 45%,   /* Oro medio */
    #ffffff 50%,   /* Reflejo de luz central */
    #bf953f 55%,   /* Oro medio */
    #a67c00 70%    /* Oro profundo */
  );
  
  background-size: 200% auto;
  -webkit-background-clip: text; /* Recorta el fondo al texto */
  background-clip: text;
  color: transparent;           /* Hace el texto transparente para ver el fondo */

  /* Sombra suave para dar relieve metálico */
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  
  /* Suavizado para fuentes cursivas largas */
  -webkit-font-smoothing: antialiased;
  display: block; 
}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}
.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}
.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}
/* ==================== BOTÓN DORADO (CON IMAGEN) ==================== */
.btn-rosa {
  /* Aseguramos que sea visible para GSAP */
  display: flex !important; 
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 14px;

  /* Imagen Dorada */
  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f; /* Respaldo */

  /* Texto */
  color: #1a1a1a !important;
  -webkit-text-fill-color: #1a1a1a !important;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;

  /* Estética */
  box-shadow: 0 8px 20px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.5);
  border: 1px solid #8a6d3b;
  cursor: pointer;
  z-index: 99; /* Bien al frente */
  overflow: hidden;
  
  /* Evitamos que el navegador lo oculte antes de que GSAP actúe */
  opacity: 1; 
}

/* El destello mágico se mantiene igual */
.btn-rosa::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.4), rgba(255,255,255,0));
  transform: skewX(-25deg);
}

.btn-rosa:hover::after {
  left: 150%;
  transition: all 0.6s ease;
}

/* ==================== LÍNEA VERTICAL ==================== */
.linea-wrapper{ height: 64px; display:flex; justify-content:center; align-items:flex-start; margin-top: 12px; }
.linea{
  width: 1px; height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{ font-size: 32px; }
  .hora{ font-size: 22px; }
  .lugar{ font-size: 16px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  *{ transition: none !important; animation: none !important; }
}








/* ===== Escena final (degradado + flores) ===== */
.lux-escena-final{
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;  
  margin-bottom: 50px;          /* pequeño respiro respecto a la tarjeta */
  overflow: visible;
}

.lux-degradado{
  width: 100%;
  height: 180px;              /* ajusta la altura del degradado a tu gusto */
  background: linear-gradient(
    to top,
    #f6d5e5 0%,               /* rosa baby base */
    rgba(246,213,229,0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
}

/* Flores pegadas al borde inferior con ligera sombra */
.lux-flores{
  position: absolute;
  bottom: -2px;               /* -2 para tocar el límite inferior visualmente */
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);    /* ancho generoso estilo portada */
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.08));
  opacity: 0.98;
}

</style>
